import { z } from 'zod';

/**
 * Zod schemas for the admin External Users modals (invite + edit-projects).
 *
 * Looser than the backend Zod equivalents (per the same UX-immediacy convention as
 * pages/external/_schemas.ts). Server is source of truth for project-validity,
 * cross-table email uniqueness, etc.
 *
 * Error copy is locked by 15-03-PLAN <interfaces>: do not paraphrase.
 */

export const inviteExternalUserSchema = z.object({
  email: z
    .string()
    .min(1, 'Email is invalid.')
    .email('Email is invalid.')
    .max(254)
    .transform((v) => v.toLowerCase()),
  firstName: z
    .string()
    .min(1, 'First name is required.')
    .max(200)
    .transform((s) => s.trim())
    .refine((s) => s.length > 0, 'First name is required.'),
  lastName: z
    .string()
    .min(1, 'Last name is required.')
    .max(200)
    .transform((s) => s.trim())
    .refine((s) => s.length > 0, 'Last name is required.'),
  projectIds: z
    .array(z.number().int().positive())
    .min(1, 'At least one project is required.')
    .max(100), // must match MAX_PROJECT_IDS in backend/src/api/schemas/externalUserAdmin.ts
});
export type InviteExternalUserInput = z.infer<typeof inviteExternalUserSchema>;

export const editProjectsSchema = z.object({
  // length 0 is valid — clears all bindings (mirrors backend replaceProjectsBodySchema).
  // The UI gates "empty" via a two-step Confirm flow, not via Zod.
  projectIds: z.array(z.number().int().positive()).max(100), // must match MAX_PROJECT_IDS in backend/src/api/schemas/externalUserAdmin.ts
});
export type EditProjectsInput = z.infer<typeof editProjectsSchema>;
